import { render } from "./examPaperOrderConfirm.vue?vue&type=template&id=3cc8bab4&scoped=true"
import script from "./examPaperOrderConfirm.vue?vue&type=script&lang=js"
export * from "./examPaperOrderConfirm.vue?vue&type=script&lang=js"

import "./examPaperOrderConfirm.vue?vue&type=style&index=0&id=3cc8bab4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc8bab4"]])

export default __exports__